// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.titre {
  font-family: var(--font-bnp);
  margin-bottom: var(--spacer4);
  font-size: 2rem;
}
.titre h2 {
  text-transform: uppercase;
  margin: 0;
  font-weight: 600;
  font-size: 1em;
}
.titre .location {
  font-size: 0.7em;
  font-weight: 200;
}

.map,
.map img,
.map #mapo {
  width: 100%;
  height: 250px;
}
@media screen and (max-width: 768px) {
  .map,
  .map img,
  .map #mapo {
    height: 50vh;
  }
}

.visite-disable {
  background: #8f9d98 !important;
  border: 1px solid #8f9d98;
  cursor: default;
}

.hero img {
  object-fit: cover;
}

.hero img.loaded {
  display: block;
}

.divholder {
  background-color: #FFF;
  width: 100%;
  height: 100%;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
